import React from 'react';

interface SuggestedActionsProps {
  actions: string[];
  onSelect: (action: string) => void;
  disabled?: boolean;
}

const SuggestedActions: React.FC<SuggestedActionsProps> = ({ actions, onSelect, disabled }) => {
  if (!actions || actions.length === 0) return null;

  return (
    <div className="agent-chat__suggestions">
      {actions.map((action, idx) => (
        <button
          key={idx}
          className="agent-chat__suggestion-chip"
          onClick={() => onSelect(action)}
          disabled={disabled}
          type="button"
        >
          {action}
        </button>
      ))}
    </div>
  );
};

export default SuggestedActions;
